import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const OrganizationSettingsMembersViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
OrganizationSettingsMembersViewTopBar.displayName = "OrganizationSettingsMembersViewTopBar"
